import { combineReducers } from '@reduxjs/toolkit'
import { hydrateSlices } from './hydrateSlice'
import customer from './customerSlice'
import settings from './settingsSlice'
import salesSessions from './salesSessionsSlice'
import validation from './validationSlice'
import embedded from './embeddedSlice'
import chatInboxSlice from  './chatInboxSlice'

const appReducer = combineReducers({
  customer,
  settings,
  validation,
  embedded,
  salesSessions,
  chatInbox: chatInboxSlice,
})

const rootReducer = (state, action) => {
  if (action.type === hydrateSlices.type) {
    const next = { ...state }
    const patch = action.payload || {}
    for (const key of Object.keys(patch)) {
      if (key === 'salesSessions') continue
      if (key in next) next[key] = patch[key]
    }
    return next
  }
  return appReducer(state, action)
}

export default rootReducer
